import {
  TableChartConfigDto,
  PitcherReportChartConfigDto,
  BatterReportChartConfigDto,
  BatterSessionReportChartConfigDto,
  BatterSingleSessionReportChartConfigDto,
  PitcherSessionReportChartConfigDto,
  PitcherSingleSessionReportChartConfigDto,
  UmpireReportChartConfigDto,
  UmpireReportForAdminChartConfigDto,
  UmpireReportForSessionChartConfigDto,
  ChartType,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericDraggableCheckboxConfig from 'components/Configs/GenericDraggableCheckboxConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig =
  | BatterReportChartConfigDto
  | BatterSessionReportChartConfigDto
  | BatterSingleSessionReportChartConfigDto
  | PitcherReportChartConfigDto
  | PitcherSessionReportChartConfigDto
  | PitcherSingleSessionReportChartConfigDto
  | UmpireReportChartConfigDto
  | UmpireReportForSessionChartConfigDto
  | UmpireReportForAdminChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<TableChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  chartKey: keyof TReportConfig;
  disabledVisibleStats?: string[];
};

const TableChartSidebar = <T extends ReportConfig>({
  extraChartData,
  setTempLayout,
  tempLayout,
  chartId,
  chartKey,
  disabledVisibleStats = [],
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId as ChartType, extraChartData)}
      </Typography>
      <GenericDraggableCheckboxConfig
        label={t('Visible stats')}
        draggableCheckboxes={extraChartData.visibleStats}
        setDraggableCheckboxes={(draggableCheckboxes) => {
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              visibleStats: draggableCheckboxes,
            },
          });
        }}
        useShortLabels={true}
        disabledKeys={disabledVisibleStats}
      />
    </div>
  );
};

export default TableChartSidebar;
